import styles from "./Product.module.css";
import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { addItemOrQtyToCart } from "../../../redux/userSlice";

function Product({ handleShow }) {
  const [product, setProduct] = useState(null);
  const params = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    const getProduct = async () => {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/products/${params.product_slug}`,
        method: "GET",
      });
      setProduct(response.data);
    };
    getProduct();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [params.product_slug]);

  return (
    product && (
      <>
        <Container className={styles.product_container}>
          <Row className="m-0 d-flex justify-content-between">
            <Col className=" d-flex justify-content-start p-0  rounded" lg={5}>
              <img
                className={styles.product_image}
                src={product.image}
                alt="product"
              ></img>
            </Col>
            <Col
              className={
                styles.column_info + " align-items-between justify-content-end"
              }
              lg={5}
            >
              <h1 className={styles.product_name}>{product.name}</h1>
              <p className={styles.product_description}>
                {product.description}
              </p>
              <p className={styles.product_price}>USD {product.price}</p>

              {product.stock > 0 ? (
                <>
                  <span className={styles.in_stock}> IN STOCK </span>
                  <p className={styles.stock_left}>{product.stock} left</p>
                  <button
                    className={styles.btn_add_to_cart}
                    onClick={() => {
                      dispatch(addItemOrQtyToCart(product));
                      handleShow();
                    }}
                  >
                    ADD TO CART
                  </button>
                </>
              ) : (
                <>
                  <span className={styles.out_of_stock}>OUT OF STOCK</span>
                </>
              )}
            </Col>
          </Row>
        </Container>
      </>
    )
  );
}
export default Product;
